import { Component, OnInit } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';

@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html',
  styleUrls: ['./crm.component.css']
})
export class CrmComponent implements OnInit {

  crmData: Array<any> = [
    {
      name: 'Amit Sharma',
      email: 'amit.sharma@example.com',
      mobile: '9876543210',
      createdAt: '2026-08-18T10:00:00'
    },
    {
      name: 'Neha Verma',
      email: 'neha.verma@example.com',
      mobile: '9812345678',
      createdAt: '2026-08-25T10:00:00'
    },
    {
      name: 'Rahul Mehta',
      email: 'rahul.mehta@example.com',
      mobile: '9898765432',
      createdAt: '2026-09-04T10:00:00'
    },
    {
      name: 'Priya Singh',
      email: 'priya.singh@example.com',
      mobile: '9822334455',
      createdAt: '2026-09-05T10:00:00'
    },
    {
      name: 'Suresh Iyer',
      email: 'suresh.iyer@example.com',
      mobile: '9800112233',
      createdAt: '2026-09-06T10:00:00'
    },
    {
      name: 'Ritu Arora',
      email: 'ritu.arora@example.com',
      mobile: '9877001122',
      createdAt: '2026-09-07T10:00:00'
    },
    {
      name: 'Manish Gupta',
      email: 'manish.gupta@example.com',
      mobile: '9811223344',
      createdAt: '2026-09-08T10:00:00'
    },
    {
      name: 'Anjali Rao',
      email: 'anjali.rao@example.com',
      mobile: '9899112233',
      createdAt: '2026-09-09T10:00:00'
    },
    {
      name: 'Vikram Shah',
      email: 'vikram.shah@example.com',
      mobile: '9833445566',
      createdAt: '2026-09-10T10:00:00'
    },
    {
      name: 'Pooja Nair',
      email: 'pooja.nair@example.com',
      mobile: '9866554433',
      createdAt: '2026-09-11T10:00:00'
    }
  ];
  searchText: string = '';

  constructor(
    private rsbService: RsbService,
    private rsbLookup: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.getCRMData();
  }

  getCRMData() {
    // Replace with actual API call when available
    // this.rsbService.getCRMData().subscribe((rsp) => {
    //   if(rsp.statusCode === 0 && rsp.contents) {
    //     this.crmData = rsp.contents;
    //   } else {
    //     this.crmData = [];
    //   }
    // });
  }

}
